<template>
  <div>
    <div v-if="loading" class="attachment-image" :style="loadingStyle" />
    <img
      v-else
      class="attachment-image"
      :src="actualSrc"
      :alt="alt"
      :width="width"
      :height="height"
      :draggable="draggable"
    />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
const blankImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='

export default {
  props: ['src', 'backgroundColor', 'alt', 'width', 'height', 'draggable'],
  data() {
    return {
      success: false,
      fail: false,
    }
  },
  computed: {
    actualSrc() {
      if (this.success) {
        return this.src
      }
      return blankImage
    },
    loading() {
      return !this.success && !this.fail
    },
    loadingStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: `${this.width}px`,
        height: `${this.height}px`,
      }
    },
  },
  watch: {
    src() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.success = false
      this.fail = false
      const image = new Image()
      image.onload = () => {
        this.success = true
        this.$emit('load')
      }
      image.onerror = () => {
        this.fail = true
        this.$emit('error')
      }
      image.src = this.src
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
img {
  display: block;
}
div.attachment-image {
  position: relative;
}
div.attachment-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  animation-name: image-loading-animation;
  animation-duration: 5s;
  animation-iteration-count: infinite;
}

@keyframes image-loading-animation {
  0%,
  100% {
    background-color: rgba(0, 0, 0, 0.1);
  }
  50% {
    background-color: rgba(255, 255, 255, 0.1);
  }
}
</style>
